/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Quill from "quill";

require('./bootstrap');
require('./lity');
/**
 * Zaciągnięcie plików json z tłumaczeniami dla komponentów Vue
 */
let project = document.head.querySelector('meta[name="app-project"]').getAttribute('content');
window.pl = require('../lang/'+project+'/pl');
window.en = require('../lang/'+project+'/en');
window.Vue = require('vue');
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import '@babel/polyfill'
import 'url-polyfill';
import 'ie11-custom-properties';
import VueBrowserUpdate from 'vue-browserupdate';
import Vue from "vue";
import cssVars from 'css-vars-ponyfill';

cssVars({
});

import Clipboard from 'v-clipboard' //https://www.npmjs.com/package/v-clipboard
import Notifications from 'vue-notification' //https://www.npmjs.com/package/vue-notification
import LvColorPicker from 'lightvue/color-picker';

Vue.use(Clipboard);
Vue.use(Notifications);
Vue.use(VueBrowserUpdate, {
    options: {
        l: document.documentElement.lang,
    },
});
Vue.component('LvColorPicker', LvColorPicker);

//QUILL TEXT EDITOR
import Vue2Editor from "vue2-editor";
import ImageResize from "quill-image-resize-module";
import QuillImageDropAndPaste from 'quill-image-drop-and-paste'
Vue.use(Vue2Editor);
const ImageFormatAttributesList = [
    'alt',
    'height',
    'width',
    'style'
];

const BaseImageFormat = Quill.import('formats/image');
class ImageFormat extends BaseImageFormat {
    static formats(domNode) {
        return ImageFormatAttributesList.reduce(function(formats, attribute) {
            if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
            }
            return formats;
        }, {});
    }
    format(name, value) {
        if (ImageFormatAttributesList.indexOf(name) > -1) {
            if (value) {
                this.domNode.setAttribute(name, value);
            } else {
                this.domNode.removeAttribute(name);
            }
        } else {
            super.format(name, value);
        }
    }
}
Quill.register(ImageFormat, true);
Quill.register('modules/imageResize', ImageResize, true);
Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste, true);


require('./prototypes/lang');
Vue.component('b-tabs', BTabs);
Vue.component('b-tab', BTab);
Vue.component('b-table', BTable);

import axios from "axios";
import {BTab, BTable, BTabs} from "bootstrap-vue";

Vue.prototype.$globalBaseURL = '';
if (process.env.MIX_APP_SUBDIRECTORY !== '') {
    axios.defaults.baseURL = '/' + process.env.MIX_APP_SUBDIRECTORY;
    Vue.prototype.$globalBaseURL = '/' + process.env.MIX_APP_SUBDIRECTORY;
}

const app = new Vue({
    el: '#app',
    data: {
        navbarHeight: 0,
        footerHeight: 0,
    },
    computed: {
        mainContentPadding: function () {
            var navbar = this.$refs.projectNavbar;
            var footerOffset = this.footerHeight + 10;
            var navbarOffset = 0;

            if (navbar && getComputedStyle(navbar).position === 'fixed') {
                navbarOffset = this.navbarHeight;
            }
            return navbarOffset + 'px 0px ' + footerOffset + 'px 0px';
        },
        mainContentPosition: function () {
            return 'absolute';
        }
    },
    methods: {
        setNavbarFooterHeight: function () {
            if (this.$refs.projectNavbar) {
                this.navbarHeight = this.$refs.projectNavbar.clientHeight;
                this.footerHeight = this.$refs.projectFooter.clientHeight;
                $(this.$refs.projectFooter).removeClass('invisible');
            }
        }
    },
    mounted: function () {
        window.addEventListener('resize', this.setNavbarFooterHeight);
        window.addEventListener("load", this.setNavbarFooterHeight);
    }
});
